import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box } from 'lucide-react'
import api from '../../services/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setLoading(true); setError('')
    try {
      await api.post('/forgot-password', { email })
      setSubmitted(true)
    } catch (err) {
      // Backend always returns 200 to prevent enumeration; surface
      // other failures (network, etc.) instead of silently swallowing.
      setError(err.response?.data?.message || 'Something went wrong.')
    } finally { setLoading(false) }
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2.5 justify-center mb-8 hover:opacity-80 transition-opacity" aria-label="Go to Stovalt home">
          <div className="w-9 h-9 bg-brand-500 rounded-xl flex items-center justify-center">
            <Box size={18} className="text-white" />
          </div>
          <span className="font-display font-700 text-white text-xl">Stovalt</span>
        </Link>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
          <h1 className="font-display text-xl font-700 text-white mb-1">Reset your password</h1>
          <p className="text-slate-400 text-sm mb-6">We'll email you a link to set a new one.</p>

          {submitted ? (
            <div className="px-3 py-2.5 bg-emerald-500/10 border border-emerald-500/20 rounded-lg text-sm text-emerald-300">
              If an account matches that email, a reset link is on its way.
            </div>
          ) : (
            <>
              {error && (
                <div className="mb-4 px-3 py-2.5 bg-red-500/10 border border-red-500/20 rounded-lg text-sm text-red-300">
                  {error}
                </div>
              )}
              <form onSubmit={submit} className="space-y-3">
                <div>
                  <label className="block text-xs text-slate-400 uppercase tracking-wider mb-1.5">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$"
                    title="Enter a valid email address"
                    className="block w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm"
                    placeholder="you@example.com"
                  />
                </div>
                <button type="submit" disabled={loading} className="w-full px-5 py-2.5 rounded-lg bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold disabled:opacity-50">
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
            </>
          )}

          <p className="text-center text-xs text-slate-400 mt-5">
            <Link to="/login" className="text-brand-400 hover:text-brand-300">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  )
}
